import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { convertPrice, formatMoney } from '../../util/currency';
import { propTypes } from '../../util/types';
import { resolveLatestProcessName, getProcess } from '../../transactions/transaction';

import css from './OrderBreakdown.module.css';
import classNames from 'classnames';

const LineItemTotalPrice = props => {
  const { transaction, isProvider, intl, lineItemClass, lineItemTotalClass, exchangeRates, currentUserCurrency } = props;


  const processName = resolveLatestProcessName(transaction?.attributes?.processName);
  if (!processName || exchangeRates.length === 0) {
    return null;
  }
  const process = getProcess(processName);
  const isCompleted = process.isCompleted(transaction?.attributes?.lastTransition);
  const isRefunded = process.isRefunded(transaction?.attributes?.lastTransition);

  let providerTotalMessageId = 'OrderBreakdown.providerTotalDefault';
  if (isCompleted) {
    providerTotalMessageId = 'OrderBreakdown.providerTotalReceived';
  } else if (isRefunded) {
    providerTotalMessageId = 'OrderBreakdown.providerTotalRefunded';
  }

  const totalLabel = isProvider ? (
    <FormattedMessage id={providerTotalMessageId} />
  ) : (
    <FormattedMessage id="OrderBreakdown.total" />
  );

  const totalPrice = isProvider
    ? transaction.attributes.payoutTotal
    : transaction.attributes.payinTotal;


  const convertedTotal = convertPrice(exchangeRates, totalPrice.amount, totalPrice.currency, currentUserCurrency)
  const formattedTotalPrice = formatMoney(intl, convertedTotal);

  return (
    <>
      <hr className={css.totalDivider} />
      <div className={classNames(css.lineItemTotal, lineItemClass)}>
        <div className={css.totalLabel}>{totalLabel}</div>
        <div className={classNames(css.totalPrice, lineItemTotalClass)}>{formattedTotalPrice}</div>
      </div>
    </>
  );
};

LineItemTotalPrice.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemTotalPrice;
